<template>
  <div class="current-cycle">
    <coming-soon-modal :dialog.sync="dialog" />
    <!-- Device current state information -->
    <v-list>
      <!-- Equipment state icon -->
      <v-list-tile class="left-align-tile">
        <v-list-tile-action class="status">
          <v-icon :color="$ponceConfig.checkStatus(device.Event ? device.Event.State.value : STATES.OFF)">trip_origin</v-icon>
        </v-list-tile-action>
        <!-- Current state info -->
        <v-list-tile-content>
          <v-list-tile-title class="device-state">{{device.Event ? state : STATES_LABELS[STATES.OFF]}}</v-list-tile-title>
          <v-list-tile-sub-title v-if="device.Event">Desde {{firstStatePoint ? convertDate(firstStatePoint.dateTime) : ''}}</v-list-tile-sub-title>
          <v-list-tile-sub-title v-else>Sin datos</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider />
    <!-- Device current cycle information -->
    <!-- Irrigating current cycle info -->
    <v-layout v-if="device.Event && device.Event.State.value == STATES.IRRIGATING" row wrap>
      <v-flex xs6 >
        <v-card style="height: 100%"class="grid" tile flat>
          <v-carousel id="carousel-current-cycle" ref="carousel-1" :cycle="false" :hide-controls="true" height="100%">
            <v-carousel-item>
              <div
                @click="changeSlide('next', 1)"
              >
                <v-card-title class="justify-center">
                  LAMINA
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="handleTooltip($event)" class="ml-1 mb-1.5" color="#00202F" small mx-3>error_outline</v-icon>
                    </template>
                    <span>Milímetros promedio aplicados con la velocidad actual</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-title class="value justify-center">{{device.Event.sheet || '-'}}<strong class="padding-space-text">mm.</strong></v-card-title>
              </div>
            </v-carousel-item>
            <v-carousel-item
            >
              <div
                @click="changeSlide('previous', 1)"
              >
                <v-card-title class="justify-center">
                  SENTIDO DE GIRO
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="handleTooltip($event)" class="ml-1 mb-1.5" color="#00202F" small mx-3>error_outline</v-icon>
                    </template>
                    <span>Dirección de movimiento</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-title class="value justify-center">{{ device.Event.direction == 'F' ? 'Horario' : 'Antihorario' }}</v-card-title>
              </div>
            </v-carousel-item>
          </v-carousel>

        </v-card>

      </v-flex>
      <v-flex xs6>
        <v-card style="height: 100%"class="grid" tile flat>
          <v-card-title class="justify-center">PRESIÓN</v-card-title>
          <v-card-title class="value justify-center">{{device.Event.pressure ? device.Event.pressure : '-'}}<strong class="padding-space-text">bar</strong>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-divider></v-divider>
      <v-flex xs6>
        <v-card style="height: 100%"class="grid" tile flat>
          <v-card-title class="justify-center">VELOCIDAD ACTUAL</v-card-title>
          <v-card-title class="value justify-center">{{currentSpeed ? currentSpeed.toFixed(2) : '-'}}<strong class="padding-space-text">m/h</strong>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs6>
        <v-card style="height: 100%"class="grid" tile flat>
          <v-card-title class="justify-center">TIEMPO REGADO</v-card-title>
          <v-card-title class="value justify-center">{{ irrigatedTime ? irrigatedTime.toFixed(2) : '-' }}<strong class="padding-space-text">hs</strong></v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-flex class="detail-btn-div" xs-12>
      <v-btn class="detail-btn" block color="info" @click="comingsoon">Detalle del ciclo</v-btn>
    </v-flex>
    <app-snackbar
      :text = "snackBarText"
      :show.sync = "snackbar"
      :color = "snackbarColor"
      :timeOut = "timeOut"
    />
  </div>
</template>

<script>

import moment from 'moment';
import { STATES_LABELS, STATES } from '../../../constants/constants';
import { DEVICE_TIMELINE_QUERY } from '../../../constants/graphql';
import _orderBy from 'lodash/orderBy';
import _last from 'lodash/last';
import _findIndex from 'lodash/findIndex';

export default {
  props: {
    device: {
      type: Object,
      default: {}
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialog: false,
      timeOut: 5000,
      snackbar: false,
      snackBarText: '',
      snackbarColor: 'red',
      loading: true,
      averagePressure: 0,
      averageApplicationRate: 0,
      lastPeriodAngles: '',
      show: true,
      STATES,
      STATES_LABELS,
      allEvents: []
    };
  },
  apollo: {
    allEvents: {
      query: DEVICE_TIMELINE_QUERY,
      variables () {
        return {
          id: parseInt(this.id)
        };
      },
      result (res) {
        let data = res.data.allEvents;
        this.allEvents = _orderBy(data, ['dateTime'], ['desc']).filter(event => !event.note);
      }
    }
  },
  computed: {
    state () {
      return this.device.Event.State.label;
    },
    currentSpeed () {
      // There must be at least two events
      if (this.allEvents.length < 2) return;

      // Check if the last two events are irrigation events
      if (this.device.Event.State.value !== STATES.IRRIGATING || this.allEvents[1].State.value !== STATES.IRRIGATING) return;

      return ((this.getDiffAngle(this.allEvents[1].direction, this.allEvents[0].angle, this.allEvents[1].angle) / (new Date(this.allEvents[0].dateTime) - new Date(this.allEvents[1].dateTime)) * 1000 * 60) * 60 * Math.PI / 180) * this.device.length;
    },
    firstStatePoint () {
      const index = _findIndex(this.allEvents, (event) => event.State.value !== this.allEvents[0].State.value);

      if (index === -1) {
        return _last(this.allEvents);
      }

      return this.allEvents[index - 1];
    },
    irrigatedTime () {
      if (!this.firstStatePoint) return;
      return moment().diff(moment(this.firstStatePoint.dateTime)) / 1000 / 60 / 60;
    }
  },
  methods: {
    comingsoon () {
      mixpanel.track('Click cycle detail');
      gtag('event', 'click_cycle_detail', {event_category: 'click', event_label: 'Click cycle detail'});
      this.dialog = true;
    },
    getLt () {
      let now = new Date().getTime();
      let from = this.device.state.current.firstSnapshot.createdAt.toDate().getTime();
      return ((this.device.pump.flow / 3.6) * (now - from) / 1000).toFixed(0);
    },
    diffDates () {
      const dtState = moment(this.device.state.current.firstSnapshot.createdAt.toDate());
      const dtNow = moment();

      // Difference in ms
      const ms = dtNow.diff(dtState);
      // Moment object of the previous ms
      const diff = moment.duration(ms);
      let msg = '';

      if (diff.days() === 1) {
        msg += diff.days() + ' día ';
      } else if (diff.days() > 1) {
        msg += diff.days() + ' días';
      }

      if (diff.hours() === 1) {
        if (msg === '') {
          msg += diff.hours() + ' hora ';
        } else {
          msg += ', ' + diff.hours() + ' hora ';
        }
      } else if (diff.hours() > 1) {
        if (msg === '') {
          msg += diff.hours() + ' horas';
        } else {
          msg += ', ' + diff.hours() + ' horas';
        }
      }

      if (diff.minutes() === 1) {
        if (msg === '') {
          msg += diff.minutes() + ' minuto ';
        } else {
          msg += ', ' + diff.minutes() + ' minuto ';
        }
      } else if (diff.minutes() > 1) {
        if (msg === '') {
          msg += diff.minutes() + ' minutos';
        } else {
          msg += ', ' + diff.minutes() + ' minutos';
        }
      } else if (diff.minutes() === 0 && msg === '') {
        msg += 'unos segundos';
      }
      return msg;
    },
    convertDate (timestamp) {
      const reference = moment(new Date(timestamp));
      const today = moment().startOf('day');
      const yesterday = today.clone().subtract(1, 'days').startOf('day');

      if (today.isSame(reference, 'day')) {
        return `hoy a las ${reference.format('hh:mm a')}`;
      } else if (yesterday.isSame(reference, 'day')) {
        return `ayer a las ${reference.format('hh:mm a')}`;
      } else {
        return `${reference.format('DD/MM')} a las ${reference.format('hh:mm a')}`;
      }
    },
    handleTooltip (event) {
      event.stopPropagation();
    },
    getDiffAngle (direction, newAngle, oldAngle) {
      if (direction === 'F') {
        if (oldAngle > newAngle) {
          return 360 - oldAngle + newAngle;
        } else {
          return newAngle - oldAngle;
        }
      } else {
        if (newAngle > oldAngle) {
          return 360 - newAngle + oldAngle;
        } else {
          return oldAngle - newAngle;
        }
      }
    },
    changeSlide (change, carouselNumber) {
      if (change === 'next') {
        this.$refs[`carousel-${carouselNumber}`].next();
      } else if (change === 'previous') {
        this.$refs[`carousel-${carouselNumber}`].prev();
      }
    }
  }
};
</script>

<style>
#carousel-current-cycle {
  display: flex;
  flex-flow: column nowrap;
}
#carousel-current-cycle .v-window__container {
  flex: 1;
}
#carousel-current-cycle .v-carousel__item {
  height: unset !important;
}

#carousel-current-cycle .v-carousel__controls {
  position: relative;
  flex: 0 0 30px;
}

#carousel-current-cycle .v-carousel__controls__item:before {
  left: 11px;
  top: 11px;
  height: 6px;
  width: 6px;
  border: 1px solid #C4C4C4;
}

#carousel-current-cycle .v-btn--active:before{
  left: 9.55px;
  top: 9.55px;
  height: 9px;
  width: 9px;
  border: 1px solid #0098e1;
  color: #0098e1
}

#carousel-current-cycle .v-btn {
  margin: 1px -7px !important;
}
</style>


// WEBPACK FOOTER //
// CurrentCycle.vue?702240a7